import { render, staticRenderFns } from "./PageStatic.vue?vue&type=template&id=f2157366&"
import script from "./PageStatic.vue?vue&type=script&lang=js&"
export * from "./PageStatic.vue?vue&type=script&lang=js&"
import style0 from "./PageStatic.vue?vue&type=style&index=0&id=f2157366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports